import logInDevMode from '@/services/backend/logInDevMode';
import { cond, propEq, T } from 'ramda';
import router from '@/router/index';
import { toRaw } from 'vue';
import { goToHomeScreenFor } from '@/services/ApiUtility';
import { useGlobalState } from '@/store/user.store';

const isSessionTimeOut = propEq(401, 'status');
const isAlreadyAuthenticated = propEq(409, 'status');

const { userState } = useGlobalState();

const withRedirectOnUnauthorizedStatusCode = cond([
  [
    isSessionTimeOut,
    async () => {
      await router.push({ name: 'login' });
      return null;
    },
  ],
  [
    isAlreadyAuthenticated,
    () => {
      goToHomeScreenFor(toRaw(userState));
      return null;
    },
  ],
  [T, (responseObject) => responseObject],
]);

const sessionAwareApiCall = async (apiCall) => {
  const response = await apiCall;
  logInDevMode(response);
  return withRedirectOnUnauthorizedStatusCode(response);
};

export default sessionAwareApiCall;
